<template>
  <div>
    <SidebarSearch
      @submit="submitForm"
      @clear="clearForm"
    >
      <SearchCollapse
        :expanded="true"
        title="Filtros"
      >
        <NxInput
          name="description"
          type="text"
          label="Usuário (Nome ou Login):"
          placeholder="Digite o nome ou login do usuário"
          :value="form.description"
          @update:value="handleInputUpdate('description', $event, false)"
        />

        <NxSelectFuncionario
          :multiple="false"
          :variable="employeeTypes.RESPONSAVEL_ACAO"
          :value="form.authorId"
          @update:value="handleSelectUpdate('authorId', $event)"
        />

        <div class="form-group">
          <label>Ação:</label>
          <v-select
            v-model="selectedActions"
            :options="actionOptions"
            multiple
            placeholder="Selecione as ações"
            label="label"
            class="w-100"
          />
        </div>

        <NxInputDateRange
          label="Período:"
          :initialValue="dateRange.startDate"
          :finalValue="dateRange.endDate"
          @update:InitialValue="handleInputDateUpdate('startDate', $event, false)"
          @update:FinalValue="handleInputDateUpdate('endDate', $event, false)"
        />
      </SearchCollapse>
    </SidebarSearch>
  </div>
</template>

<script>
import { NxInputDateRange } from '@/components/nexum/components/custom-inputs/index.js'
import { NxSelectFuncionario } from '@/components/nexum/components/custom-selects/index.js'
import NxInput from '@/components/nexum/components/inputs/NxInput.vue'
import SidebarSearch from '@/containers/layout/sidebars/SidebarSearch.vue'
import SearchCollapse from '@/containers/layout/sidebars/components/SearchCollapse.vue'
import vSelect from 'vue-select'
import employeeTypes from '@/enums/enumEmployeeTypes.js'

export default {
  name: 'SidebarLogsTags',
  components: {
    SidebarSearch,
    SearchCollapse,
    NxSelectFuncionario,
    NxInput,
    NxInputDateRange,
    'v-select': vSelect
  },
  data () {
    return {
      employeeTypes: employeeTypes,
      form: {
        description: null,
        authorId: null,
        startDate: null,
        endDate: null
      },
      dateRange: {
        startDate: null,
        endDate: null
      },
      selectedActions: [],
      actionOptions: [
        { value: 'CRIAR', label: 'Criação' },
        { value: 'EDITAR', label: 'Alteração' },
        { value: 'EXCLUIR', label: 'Exclusão' }
      ]
    }
  },
  methods: {
    handleInputUpdate (key, value, trim = true) {
      this.form[key] = trim && value ? value.trim() : value
    },

    handleSelectUpdate (key, value) {
      this.form[key] = value
    },

    handleInputDateUpdate (key, value) {
      if (value) {
        const date = new Date(value)
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, '0')
        const day = String(date.getDate()).padStart(2, '0')

        if (key === 'startDate') {
          this.form[key] = `${year}-${month}-${day} 00:00:00`
        } else if (key === 'endDate') {
          this.form[key] = `${year}-${month}-${day} 23:59:59`
        }
      } else {
        this.form[key] = null
      }
    },

    submitForm () {
      const filters = { area: 'TAGS' }

      if (this.form.description) {
        filters.description = this.form.description
      }

      if (this.form.authorId) {
        filters.authorId = this.form.authorId
      }

      if (this.selectedActions.length > 0) {
        filters.action = this.selectedActions.map(a => a.value)
      }

      if (this.form.startDate) {
        filters.startDate = this.form.startDate
      }

      if (this.form.endDate) {
        filters.endDate = this.form.endDate
      }

      this.$emit('apply-filters', filters)
    },

    clearForm () {
      this.form = {
        description: null,
        authorId: null,
        startDate: null,
        endDate: null
      }
      this.selectedActions = []
      this.$emit('clear-filters')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/private/auditoria/logs-tags/components/search/SidebarLogsTags.vue